const ID = 'checkbox';

export default ID;
